import './api.d.ts'
import { NgModule } from '@angular/core'

@NgModule({})
export class APIModule { }

export { APIService } from './services/api.service'
export { HttpInterceptorService } from './services/interceptor.service'
export { BOOTSTRAP_DATA } from './providers'
